import * as React from 'react';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Box, Divider, FormControl, FormControlLabel, FormLabel, IconButton, Radio, RadioGroup, Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from 'react-router-dom';

import { ACCOUNT_CODE_LIVE, ACCOUNT_CODE_PAPERTRADING } from '../../../assets/constants';
import { logout } from '../../../store/auth/service';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { updateSystemProfileAsync } from '../../../store/system-profile/service';
import SystemProfileDialog from '../../dialogs/SystemProfileDialog';

const AccountMenu: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [showSystemProfileDialog, setShowSystemProfileDialog] = React.useState(false);

  const { firstName } = useAppSelector((gs) => gs.authState);
  const { profile, pending } = useAppSelector((gs) => gs.systemProfileState);

  const handleAccountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (profile) {
      dispatch(updateSystemProfileAsync({ ...profile, activeAccountCode: e.target.value }));
    }
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSystemProfileBtnClick = () => {
    setShowSystemProfileDialog(true);
    handleClose();
  };

  const handleLogOutBtnClick = (): void => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <div>
      <Tooltip title={firstName}>
        <IconButton
          color="primary"
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          <AccountCircleIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuItem onClick={handleClose}>{`Hey ${firstName}! 👋`}</MenuItem>
        <Divider />
        {profile && (
          <Box sx={{ px: 2, py: 1 }}>
            <FormControl>
              <FormLabel id="account-radio-group-label" sx={{ fontSize: '0.75rem' }}>
                Account
              </FormLabel>
              <RadioGroup aria-labelledby="account-radio-group-label" value={profile.activeAccountCode} onChange={handleAccountChange}>
                <FormControlLabel
                  value={ACCOUNT_CODE_LIVE}
                  disabled={pending}
                  control={<Radio size="small" />}
                  label={`${ACCOUNT_CODE_LIVE} (live)`}
                />
                <FormControlLabel
                  value={ACCOUNT_CODE_PAPERTRADING}
                  disabled={pending}
                  control={<Radio size="small" />}
                  label={ACCOUNT_CODE_PAPERTRADING}
                />
              </RadioGroup>
            </FormControl>
          </Box>
        )}
        <Divider />
        <MenuItem onClick={handleSystemProfileBtnClick}>Settings</MenuItem>
        <Button variant="text" fullWidth sx={{ px: 2, justifyContent: 'flex-start' }} onClick={handleLogOutBtnClick}>
          Log out
        </Button>
      </Menu>
      {showSystemProfileDialog && (
        <SystemProfileDialog isOpen={showSystemProfileDialog} onClose={() => setShowSystemProfileDialog(false)} />
      )}
    </div>
  );
};

export default AccountMenu;
